import { toast } from 'react-toastify';
import { addSupplier, AddSupplierFormValue } from './addSupplier';

export const addSupplierDtoInitialValues: AddSupplierFormValue = {
  name: '',
};

export const useAddSupplierData = () => {
  const initialValues = addSupplierDtoInitialValues;

  async function submitAddSupplier(values: AddSupplierFormValue) {
    const res = await addSupplier(values);
    if (res.type === 'success') {
      toast.success('Successfully added brand');
      return res.data;
    }
    toast.error(res.error.message);

    return null;
  }

  return { submitAddSupplier, initialValues };
};
